type DataHandler<T> = (data?: T) => void;
interface ILiteEvent<T> {
  off(handler: DataHandler<T>): void;
  on(handler: DataHandler<T>): () => void;
}

export default class LiteEvent<T> implements ILiteEvent<T> {
  private handlers: Array<DataHandler<T>> = [];

  public expose(): ILiteEvent<T> {
    return this;
  }

  public off(handler: DataHandler<T>): void {
    this.handlers = this.handlers.filter((h) => h !== handler);
  }

  public on(handler: DataHandler<T>): () => void {
    this.handlers.push(handler);
    return () => this.off(handler);
  }

  public trigger(data?: T) {
    this.handlers.slice(0).forEach((h) => h(data));
  }
}
